// constants related to general formatting

/**
 * Value intended to be used in table cells, or similar places where you wanna display that value has been received
 * but it's `null`, `undefined`, or `NaN` for example
 */
export const EMPTY_DISPLAY_VALUE = '-';

/**
 * General format expected to be sent to the BE for example
 *
 * This format is also used by DatePicker for example by default
 */
export const DATE_PAYLOAD_FORMAT = 'YYYY-MM-DD';
